import React from 'react';
import { BookOpenIcon, ShieldCheckIcon, EyeIcon, MapIcon, WifiOffIcon, HeadphonesIcon, ZapIcon } from 'lucide-react';
export function OfferSection() {
  return <section className="py-16 px-4 bg-navy-950 relative border-y border-navy-800" data-id="element-151">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(178,34,52,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-152"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-153">
        <div className="mb-12 md:text-center" data-id="element-154">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 font-serif" data-id="element-155">
            Everything Inside Your Exclusive Access
          </h2>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto" data-id="element-156">
            Five fundamental pillars to dominate the present and survive the
            future.
          </p>
        </div>

        <div className="grid gap-5" data-id="element-157">
          {/* Item 1 */}
          <div className="flex flex-col md:flex-row gap-5 p-6 md:p-8 glass-card rounded-2xl hover:border-patriot-red/40 transition-all duration-500 group hover:shadow-[0_10px_40px_rgba(178,34,52,0.08)] relative overflow-hidden" data-id="element-158">
            <div className="absolute top-0 right-0 p-6 text-6xl font-black text-white/[0.03] group-hover:text-patriot-red/[0.05] transition-colors pointer-events-none" data-id="element-159">
              01
            </div>
            <div className="flex-shrink-0" data-id="element-160">
              <div className="w-16 h-16 rounded-xl bg-navy-900/50 border border-patriot-red/20 flex items-center justify-center group-hover:bg-patriot-red/10 group-hover:border-patriot-red/50 transition-colors shadow-inner" data-id="element-161">
                <BookOpenIcon className="w-8 h-8 text-patriot-red/70 group-hover:text-patriot-red" data-id="element-162" />
              </div>
            </div>
            <div className="flex-1" data-id="element-163">
              <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-2" data-id="element-164">
                <h3 className="text-2xl font-bold text-white font-serif" data-id="element-165">
                  The Utah Chronicle
                </h3>
                <span className="inline-block px-3 py-1 text-xs font-bold tracking-widest text-gold-900 bg-gold-400 rounded-full self-start" data-id="element-166">
                  VALUE: $47
                </span>
              </div>
              <p className="text-slate-400 leading-relaxed text-lg" data-id="element-167">
                The detailed account of September 10, 2025 and why the security
                systems failed. A forensic analysis of how the system allows the
                unthinkable to happen.
              </p>
            </div>
          </div>

          {/* Item 2 */}
          <div className="flex flex-col md:flex-row gap-5 p-6 md:p-8 glass-card rounded-2xl hover:border-patriot-red/40 transition-all duration-500 group hover:shadow-[0_10px_40px_rgba(178,34,52,0.08)] relative overflow-hidden" data-id="element-168">
            <div className="absolute top-0 right-0 p-6 text-6xl font-black text-white/[0.03] group-hover:text-patriot-red/[0.05] transition-colors pointer-events-none" data-id="element-169">
              02
            </div>
            <div className="flex-shrink-0" data-id="element-170">
              <div className="w-16 h-16 rounded-xl bg-navy-900/50 border border-patriot-red/20 flex items-center justify-center group-hover:bg-patriot-red/10 group-hover:border-patriot-red/50 transition-colors shadow-inner" data-id="element-171">
                <ShieldCheckIcon className="w-8 h-8 text-patriot-red/70 group-hover:text-patriot-red" data-id="element-172" />
              </div>
            </div>
            <div className="flex-1" data-id="element-173">
              <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-2" data-id="element-174">
                <h3 className="text-2xl font-bold text-white font-serif" data-id="element-175">
                  The Cultural Warrior's Decalogue
                </h3>
                <span className="inline-block px-3 py-1 text-xs font-bold tracking-widest text-gold-900 bg-gold-400 rounded-full self-start" data-id="element-176">
                  VALUE: $67
                </span>
              </div>
              <p className="text-slate-400 leading-relaxed text-lg" data-id="element-177">
                How to defend your values in hostile environments without losing
                your composure or dignity. Proven tactics to disarm emotional
                arguments with unbreakable truth.
              </p>
            </div>
          </div>

          {/* Item 3 */}
          <div className="flex flex-col md:flex-row gap-5 p-6 md:p-8 glass-card rounded-2xl hover:border-patriot-red/40 transition-all duration-500 group hover:shadow-[0_10px_40px_rgba(178,34,52,0.08)] relative overflow-hidden" data-id="element-178">
            <div className="absolute top-0 right-0 p-6 text-6xl font-black text-white/[0.03] group-hover:text-patriot-red/[0.05] transition-colors pointer-events-none" data-id="element-179">
              03
            </div>
            <div className="flex-shrink-0" data-id="element-180">
              <div className="w-16 h-16 rounded-xl bg-navy-900/50 border border-patriot-red/20 flex items-center justify-center group-hover:bg-patriot-red/10 group-hover:border-patriot-red/50 transition-colors shadow-inner" data-id="element-181">
                <EyeIcon className="w-8 h-8 text-patriot-red/70 group-hover:text-patriot-red" data-id="element-182" />
              </div>
            </div>
            <div className="flex-1" data-id="element-183">
              <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-2" data-id="element-184">
                <h3 className="text-2xl font-bold text-white font-serif" data-id="element-185">
                  Systemic Villain Analysis
                </h3>
                <span className="inline-block px-3 py-1 text-xs font-bold tracking-widest text-gold-900 bg-gold-400 rounded-full self-start" data-id="element-186">
                  VALUE: $47
                </span>
              </div>
              <p className="text-slate-400 leading-relaxed text-lg" data-id="element-187">
                Understand who "forged the bullet" (the media and academic
                machinery) so you can fight back. Dismantling the architecture
                of modern censorship.
              </p>
            </div>
          </div>

          {/* Item 4 */}
          <div className="flex flex-col md:flex-row gap-5 p-6 md:p-8 glass-card rounded-2xl hover:border-patriot-red/40 transition-all duration-500 group hover:shadow-[0_10px_40px_rgba(178,34,52,0.08)] relative overflow-hidden" data-id="element-188">
            <div className="absolute top-0 right-0 p-6 text-6xl font-black text-white/[0.03] group-hover:text-patriot-red/[0.05] transition-colors pointer-events-none" data-id="element-189">
              04
            </div>
            <div className="flex-shrink-0" data-id="element-190">
              <div className="w-16 h-16 rounded-xl bg-navy-900/50 border border-patriot-red/20 flex items-center justify-center group-hover:bg-patriot-red/10 group-hover:border-patriot-red/50 transition-colors shadow-inner" data-id="element-191">
                <MapIcon className="w-8 h-8 text-patriot-red/70 group-hover:text-patriot-red" data-id="element-192" />
              </div>
            </div>
            <div className="flex-1" data-id="element-193">
              <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-2" data-id="element-194">
                <h3 className="text-2xl font-bold text-white font-serif" data-id="element-195">
                  The Erika Kirk Protocol
                </h3>
                <span className="inline-block px-3 py-1 text-xs font-bold tracking-widest text-gold-900 bg-gold-400 rounded-full self-start" data-id="element-196">
                  VALUE: $97
                </span>
              </div>
              <p className="text-slate-400 leading-relaxed text-lg" data-id="element-197">
                The roadmap for new leadership in times of persecution. How to
                transform pain and loss into an unstoppable movement.
              </p>
            </div>
          </div>

          {/* Item 5 */}
          <div className="flex flex-col md:flex-row gap-5 p-6 md:p-8 glass-card rounded-2xl hover:border-patriot-red/40 transition-all duration-500 group hover:shadow-[0_10px_40px_rgba(178,34,52,0.08)] relative overflow-hidden" data-id="element-198">
            <div className="absolute top-0 right-0 p-6 text-6xl font-black text-white/[0.03] group-hover:text-patriot-red/[0.05] transition-colors pointer-events-none" data-id="element-199">
              05
            </div>
            <div className="flex-shrink-0" data-id="element-200">
              <div className="w-16 h-16 rounded-xl bg-navy-900/50 border border-patriot-red/20 flex items-center justify-center group-hover:bg-patriot-red/10 group-hover:border-patriot-red/50 transition-colors shadow-inner" data-id="element-201">
                <WifiOffIcon className="w-8 h-8 text-patriot-red/70 group-hover:text-patriot-red" data-id="element-202" />
              </div>
            </div>
            <div className="flex-1" data-id="element-203">
              <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-2" data-id="element-204">
                <h3 className="text-2xl font-bold text-white font-serif" data-id="element-205">
                  Digital Survival Guide
                </h3>
                <span className="inline-block px-3 py-1 text-xs font-bold tracking-widest text-gold-900 bg-gold-400 rounded-full self-start" data-id="element-206">
                  VALUE: $39
                </span>
              </div>
              <p className="text-slate-400 leading-relaxed text-lg" data-id="element-207">
                How to navigate censorship and ensure your message reaches who
                it needs to reach. Practical tools to avoid being erased from
                the digital map.
              </p>
            </div>
          </div>

          {/* BONUS: Audiobook */}
          <div className="flex flex-col md:flex-row gap-5 p-6 md:p-8 rounded-2xl transition-all duration-500 group relative overflow-hidden border-2 border-patriot-red/40 bg-navy-900/40 backdrop-blur-md shadow-[0_0_30px_rgba(178,34,52,0.1)]" data-id="element-208">
            <div className="absolute top-0 right-0 p-6 text-6xl font-black text-patriot-red/[0.08] pointer-events-none" data-id="element-209">
              🎧
            </div>
            <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-3 py-1 text-[10px] font-bold tracking-widest text-white bg-red-gradient uppercase rounded-full shadow-lg" data-id="element-210">
              <ZapIcon className="w-3 h-3" data-id="element-211" />
              BONUS INCLUDED
            </div>
            <div className="flex-shrink-0 mt-6 md:mt-0" data-id="element-212">
              <div className="w-16 h-16 rounded-xl bg-patriot-red/10 border border-patriot-red/40 flex items-center justify-center shadow-[0_0_15px_rgba(178,34,52,0.2)]" data-id="element-213">
                <HeadphonesIcon className="w-8 h-8 text-patriot-red" data-id="element-214" />
              </div>
            </div>
            <div className="flex-1 mt-4 md:mt-0" data-id="element-215">
              <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-2" data-id="element-216">
                <h3 className="text-2xl font-bold text-white font-serif" data-id="element-217">
                  Downloadable Audiobook
                </h3>
                <span className="inline-block px-3 py-1 text-xs font-bold tracking-widest text-gold-900 bg-gold-gradient rounded-full self-start shadow-md" data-id="element-218">
                  VALUE: $47 — FREE
                </span>
              </div>
              <p className="text-slate-300 leading-relaxed text-lg" data-id="element-219">
                Listen anywhere, anytime. The complete manifesto narrated in a
                powerful, immersive audio experience. Download the MP3 files
                instantly and absorb the message on the go — while driving,
                working out, or commuting.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center glass-card p-6 rounded-2xl border-patriot-red/20" data-id="element-220">
          <p className="text-2xl text-slate-300" data-id="element-221">
            Total Value:{' '}
            <span className="line-through text-slate-500" data-id="element-222">$344</span> —{' '}
            <strong className="text-gold-400 text-3xl" data-id="element-223">
              Yours today for just $17
            </strong>
          </p>
        </div>
      </div>
    </section>;
}